import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <a href="/" className="flex items-center space-x-2">
              <img 
                src="https://static.readdy.ai/image/207177310b9abd83a3c3d5d478fef01c/e677230c612ea5b924265b938e1949ea.png" 
                alt="Infraestructuras Holaasks" 
                className="h-14 w-auto"
              />
            </a>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <a href="#inicio" className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-200'}`}>
              Inicio
            </a>
            <a href="#nosotros" className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-200'}`}>
              Quiénes Somos
            </a>
            <a href="#servicios" className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-200'}`}>
              Servicios
            </a>
            <a href="#proyectos" className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-200'}`}>
              Proyectos
            </a>
            <a href="#contacto" className={`px-6 py-2 bg-teal-500 text-white rounded-full text-sm font-medium hover:bg-teal-600 transition-colors whitespace-nowrap`}>
              Contacto
            </a>
          </div>

          <button 
            className="md:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <div className="px-4 py-4 space-y-3">
            <a href="#inicio" className="block text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap">
              Inicio
            </a>
            <a href="#nosotros" className="block text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap">
              Quiénes Somos
            </a>
            <a href="#servicios" className="block text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap">
              Servicios
            </a>
            <a href="#proyectos" className="block text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap">
              Proyectos
            </a>
            <a href="#contacto" className="block px-6 py-2 bg-teal-500 text-white rounded-full text-center font-medium hover:bg-teal-600 transition-colors whitespace-nowrap">
              Contacto
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}